import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    justifyContent: "space-between",
  },
  headerInfo: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  title: {
    fontWeight: "bold",
    fontSize: 18,
  },
  value: {
    textAlign: "center",
    fontSize: 28,
    color: "#666",
  },
  dateContainer: {
    alignItems: "flex-end",
  },
  bold: {
    fontWeight: "bold",
    fontSize: 16,
  },
  explanationText: {
    // textAlign: "center",
    marginVertical: 16,
  },
  openButton: {
    marginBottom: 16,
  },
  codeHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  copyText: {
    color: "#256df4",
    fontSize: 16,
  },
  activityIndicatorContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
});
